import { render } from "./bead.vue?vue&type=template&id=76e1c4a7&scoped=true&ts=true"
import script from "./bead.vue?vue&type=script&lang=ts"
export * from "./bead.vue?vue&type=script&lang=ts"

import "./bead.vue?vue&type=style&index=0&id=76e1c4a7&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e1c4a7"]])

export default __exports__